/**
 * Labs strength-mark palette: neutral greys for a professional instrument read on dark UI.
 */

/** Slightly lighter / darker pair — subtle banding only, no hue shift. */
const SECTOR_GREY_A = '#2b2b30';
const SECTOR_GREY_B = '#34343a';

/** Six sector fills, pointy-top hex edge index 0→5 (alternating A/B). */
export const LABS_DIAGRAM_SECTOR_FILLS = [
  SECTOR_GREY_A,
  SECTOR_GREY_B,
  SECTOR_GREY_A,
  SECTOR_GREY_B,
  SECTOR_GREY_A,
  SECTOR_GREY_B,
];

export const LABS_DIAGRAM_LINE = 'rgba(220, 222, 226, 0.88)';
export const LABS_DIAGRAM_LINE_GUIDE = 'rgba(220, 222, 226, 0.34)';
export const LABS_DIAGRAM_LINE_VERTEX = 'rgba(220, 222, 226, 0.46)';
